export default __webpack_public_path__ + "static/media/mode-2021.4af5137c.svg";